import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { OBJECTIVE_QUERY } from '../../queries';

export function useObjectiveQuery( objectiveId, options ) {
    const { data: rawData, loading, error, refetch } = useQuery( OBJECTIVE_QUERY, {
        ...options,
        variables: { ...options?.variables, objectiveId: objectiveId },
    } );

    return useMemo ( () => {
        return {
            error,
            loading,
            data: rawData,
            refetch,
        };
    }, [ error, loading, rawData, refetch ] );
}
